import React from "react";
import PropTypes from "prop-types";

import PageSection from "../PageSection";
import BalloonAppreciateWithoutString from "./../svgs/BalloonAppreciateWithoutString";
import FooterLinks from "./FooterLinks";

import footerLinks from "../../footerLinks";

const PageFooter = props => {
    const { /* authUrl, authenticated, */ simple } = props;

    return (
        <React.Fragment>
            <PageSection sectionName="footer" simpleFooter={simple}>
                {!simple && (
                    <React.Fragment>
                        <p className="section--footer__tagline">
                            Leave for the weekend with that warm and fuzzy
                            feeling
                        </p>
                    </React.Fragment>
                )}
                <BalloonAppreciateWithoutString />
            </PageSection>
            <FooterLinks links={footerLinks} simpleFooter={simple} />
        </React.Fragment>
    );
};

PageFooter.propTypes = {
    authUrl: PropTypes.string,
    links: PropTypes.array,
    authenticated: PropTypes.bool,
    simple: PropTypes.bool
};

export default PageFooter;



// WEBPACK FOOTER //
// ./src/components/landingPage/PageFooter.jsx